import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Util from '../../../util'
import NavigatorMain from '../../NavigatorMain';
import ProductInfo from '../../product/component/ProductInfo';
import {
  getPayAll
} from '../../../getPay';
import ModalSelect from '../../Modal/ModalSelect';
class InvestmentFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serchVal:'',
      source1:[],
      serchFlag:false,
      serchSource:[]
    };
  }
  componentWillMount(){
    this.setState({
      source1:this.props.location.state.source1
    })
  }
  selectFund(item){
    let productType;
    if (item.fundTypeName=="超级基金型") {
      productType='Z'
    } else if(item.raiseMethod=='9'){
      productType='G'
    }else if(item.raiseMethod=='7'){
      productType='S'
    }else if(item.raiseMethod=='5'){
      productType='J'
    }
    if (item.fundTypeName=="超级基金型") {
      let params = {
      fundCode: item.fundCode,
      fundName: item.name,
      productType: "Z",
      pageText: "新建定投计划",
    }
    getPayAll( window.history.length, params, hashHistory, 'PaymentAllSuperFund')
    }else{
      let params={
        fundName:item.name,
        fundCode:item.fundCode,
        businessType:'T022',
        productType:productType,
        titleHeader:'新建定投计划',
        wanfenshouyi:item.wanfenshouyi,
        fundType:item.fundTypeName,
        currentNav:item.currentNav,
        currentNavDate:item.currentNavDate,
        item:item
      };
      getPayAll(window.history.length,params,hashHistory,'FixedInvestment')
    }
  }
  serchChange(e){
    this.setState({
      serchVal:e.target.value
    })
  }
  keypress = (e) => {

      e.which == 13 && this.handler()
  }
  handler(){
    let data=[]
    this.state.source1.forEach((item,i)=>{
      if (item.name.indexOf(this.state.serchVal)>-1||item.fundCode.indexOf(this.state.serchVal)>-1) {
        data.push(item)
      }
    })
    this.setState({
      serchSource:data
    })
  }
  render(){
    let { serchSource,serchFlag} = this.state;
    return (
        <div className="container plan-content" >
          <ModalSelect/>
          <NavigatorMain>
            <div className="header black">
              <input onKeyPress={this.keypress} onChange={this.serchChange.bind(this)} value={this.state.serchVal} type="search" className='serchHeader-input'></input>
              <p className='serchHeader-btn' onClick={()=>hashHistory.goBack()}>取消</p>
            </div>
          </NavigatorMain>
          <div className='content'>
            {
              serchSource.map( (item,i)=> {
                return(
                  <div  key={`invest${i}`}>
                    <ProductInfo  singlePoint={()=>this.selectFund(item)}
                        fundName={item.name}
                        valName={'近一年收益'}
                        val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                        valDate={Util.returnDate(item.currentNavDate).substr(-5)}
                        rateName={'日涨跌幅'}
                        rate={`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`}
                      />
                  </div>
                )
              })
            }
            {
              serchSource.length==0?<div className='plan-tip'>没有符合条件的产品</div>:null
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
   inInvestmentFundList:state.InvestPlanReducer.inInvestmentFundList
  }
}
export default connect(mapStateToProps)(InvestmentFund);



// WEBPACK FOOTER //
// ./src/components/myAssets/investPlan/SerchInvestment.js